import Model from '@/lib/data/Model';
import ExtensionDef from './ExtensionDef';

class PolicyExtension extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'policy_id',
        'ext_extension',
        'ext_limit',
        'ext_limit_cur',
        'extension_def_other',
        {
            name: 'extension_def',
            association: {
                type: 'one',
                model: ExtensionDef,
            },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'saveOrUpdatePolicyExtension',
            url: '/policy/extension/saveorupdate',
            associated: true,
        },
        {
            name: 'removePolicyExtension',
            url: '/policy/extension/remove',
            params: ['id'],
        },
    ];
}

export default PolicyExtension;
